<template>
  <div class="home">
    <el-button type="primary" @click="getImageId"
      >获取数据{{ imgeId }}</el-button
    >
    <el-button type="primary" @click="open">打开新链接</el-button>
    <el-button type="primary" @click="dialogVisible=true">弹窗</el-button>
    <img alt="Vue logo" src="../assets/logo.png" />
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
  data() {
    return {
      imgeId: "",
      dialogVisible:false
    };
  },
  components: {
    HelloWorld,
  },
  methods: {
    open() {
      window.open("https://www.baidu.com");
    },
    Bridge(params) {
      let s = ""; //随机数
      for (var i = 0; i < 8; i++) {
        s = `${s}${Math.floor(Math.random() * 10)}`;
      }
      let sendData = {
        action: "dld-chrome",
        params,
        method: "Bridge",
        t: new Date().getTime() + "-" + s,
      };
      window.parent.postMessage(sendData, "*");
      return new Promise((resolve, reject) => {
        let func = (res) => {
          if (
            res.data &&
            Object.prototype.toString.call(res.data === "[object Object]")
          ) {
            let { action, data } = res.data;
            if (
              action ===
              `dld-chrome-Bridge-${params.method}-callback-${sendData.t}`
            ) {
              window.removeEventListener("message", func);
              resolve(data);
            }
          }
        };
        window.addEventListener("message", func, false);
      });
    },
    getImageId() {
      this.Bridge({
        method: "get1688ImageId",
        params: {
          url: "https://cbu01.alicdn.com/img/ibank/O1CN019VxCn61QVnvYkGJUd_!!2207957381982-0-cib.jpg",
        },
      }).then((res) => {
        this.imgeId = res.data;
      });
    },
  },
};
</script>
